import { CacheInterceptor } from '@core/services';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

export function provideCache() {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true,
    },
  ];
}
